import { useQuery } from '@tanstack/react-query';

import type { PaginationRequest } from '#packages/common/utils/pagination';

import { AuditRepo } from '../services/audit-repo';

const SHARED_QUERY_KEYS = ['audits'];

export const useAuditListQuery = ({
  pagination,
}: {
  pagination: PaginationRequest;
}) =>
  useQuery({
    queryKey: [...SHARED_QUERY_KEYS, pagination],
    gcTime: Infinity,
    staleTime: Infinity,

    queryFn: AuditRepo.list.bind(undefined, { pagination }),
  });

export const useCreateAuditMutation = ({}) => {};
